import React, { useCallback, useEffect, useRef, useState } from 'react';
import BreadcrumbComponent from '../../../../components/common/Breadcrumb';
import NationalEmblem from '../../../../assets/svg_main/national_emblem.svg';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import profilePic from '../../../../assets/png/default_profile.png';
import BackArrowsvg from '../../../../assets/svg_main/BackArrowIconSvg.svg';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '@components/common/Button';
import VhndUhndOverview from '@pages/GeoNonGeo/vhnduhnd/viewVhndUhnd/VhndUhndOverview';
import { toast } from 'react-toastify';
import CopyLeft from "../../../../assets/svg/copy-left.svg"
import EditEvent from "../../../../assets/svg_main/pencil-01.svg"
import { formStateType, vhndUhndProps } from '../vhnd-interface';
import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import { setGeometryMapPoint, setMapManualAddress, setMapLatLong, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setCreateMapPincodeWithHfr, setMapServicesDown, setMapServicesCreatePolygon, setMapServicesPolygonForEdit } from '@store/actions/facilityGeoMapAction';
import { RootState } from '@store/reducers';
import { session_message, session_form_details, session_form_state, status_type, NAV_ITEMS_MODAL } from '@constants/sessionSiteConstant';
import { createSessionApi, getHealthProviderByFacilitySessionSiteApi, getMobiliserByFacilitySessionSiteApi, getSessionDetailByIdApi, getSessionDetailStatusApi, getSessionHeldAtSessionSiteApi, getSessionTypeSessionSiteApi, getUserLocationFacilityApi, getVillageCoverageSessionSiteApi, getWardCoverageSessionSiteApi, statusSessionApi, updateSessionApi } from '../sessionServices';
import SessionForm from '../sessionForm/sessionForm';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import dayjs from 'dayjs';
import { map_message } from '@constants/esriMapConstant';
import EditDuplicateVhndUhndWrapper from '../editVhndUhndWrapper';
import SessionSiteWarningModal from './sessionSiteWarningModal';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import { dateFormate, viewHeader } from '@constants/index';
import { buttonNames } from '@constants/appConstants';
import config from '@config/config';

const VhndUhndView = (props: vhndUhndProps) => {
  const { page, flow } = props;

  // code for map
  const dispatch = useDispatch();
  const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);

  const clearMapStore = () => {
    dispatch(setGeometryMapPoint({ mapPointer: '', distFenceGeometry: '' }));
    dispatch(setMapManualAddress(false));
    dispatch(setMapLatLong(null));
    dispatch(setMapManualLatLong(false));
    dispatch(setMapManualLatLongClicked(false));
    dispatch(setMapPincodeFirstTimeEdit(null));
    dispatch(setCreateMapPincodeWithHfr(null))
    dispatch(setMapServicesDown(false));
    dispatch(setMapServicesCreatePolygon(false));
    dispatch(setMapServicesPolygonForEdit(false));

    setSessionDetailsFormData(JSON.parse(JSON.stringify(session_form_details)));
    setsessionDetailsFormState(JSON.parse(JSON.stringify(session_form_state)));
    userLocationDetailsRef.current = '';
    sessionHeldAtRef.current = [];
  }
  //====================

  const [currentTab, setCurrentTab] = useState(NAV_ITEMS_MODAL[0]);
  const [tabs, setTabs] = useState<any>([]);
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [checkLastApiCallSuccess, setcheckLastApiCallSuccess] = useState<boolean>(true);
  const { id } = useParams();
  const userDetails = localStorage.getItem('userDetails');
  const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));
  const sessionDetail = useRef<any>('');
  const sessionStatus = useRef<any[]>([]);

  const [sessionDetailsFormData, setSessionDetailsFormData] = useState<any>(JSON.parse(JSON.stringify(session_form_details)));
  const [sessionDetailsFormState, setsessionDetailsFormState] = useState<formStateType>(JSON.parse(JSON.stringify(session_form_state)));
  const userLocationDetailsRef = useRef<any>('');
  const sessionHeldAtRef = useRef<any[]>([]);
  const sesssionDateRef = useRef<any>('');
  const [showWarningModal, setShowWarningModal] = useState<boolean>(false);
  const [sessionStatusType, setSessionStatusType] = useState<string>('');

  const getHealthProviderByFacilitySessionSite = async (facilityId: any, date: any) => {
    const res = await getHealthProviderByFacilitySessionSiteApi(facilityId, date, id);
    if (res) {
      const sessionHpTagged = res.data.map((key: any) => {
        return {
          value: `${key?.f_name} ${key?.l_name}`,
          label: `${key?.f_name} ${key?.l_name}`,
          id: key?.user_id,
          code: `${key?.user_code}_${key?.uf_tagged_id}`
        }
      });
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        hpTagged: {
          ...create_sessionDetails.hpTagged,
          '#options': sessionHpTagged
        }
      }));


      const hpTaggedData = sessionDetail.current.health_provider_tagged?.length > 0 ? sessionDetail.current.health_provider_tagged.map((ele: any) => {
        return `${ele?.health_provider_f_name} ${ele?.health_provider_l_name}`
      }) : '';

      const hpTaggedValue = sessionHpTagged.filter((ele: any) => hpTaggedData.includes(ele.value)).map((ele: any) => {
        return ele.value;
      });

      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        hpTagged: {
          ...prevState.hpTagged,
          value: hpTaggedValue,
          option: sessionHpTagged
        }
      }));

      if (hpTaggedValue.length > 0) {
        getMobiliserByFacilitySessionSite(hpTaggedValue, sessionHpTagged, date);
      }
    }
  };

  const getMobiliserByFacilitySessionSite = async (hpTaggedData: any, hptaggedOption: any, date: any) => {
    const mobilizerIdArray = hptaggedOption.filter((ele: any) => hpTaggedData.includes(ele.value)).map((ele: any) => {
      return ele.code.split('_')[1];
    });

    const res = await getMobiliserByFacilitySessionSiteApi(mobilizerIdArray, date, id);
    if (res) {
      const sessionMobileser = res.data.map((key: any) => {
        return {
          value: `${key?.f_name} ${key?.l_name}`,
          label: `${key?.f_name} ${key?.l_name}`,
          id: key?.mobiliser_id,
          code: key?.mobiliser_id
        }
      });

      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        mobiliserTagged: {
          ...create_sessionDetails.mobiliserTagged,
          '#options': sessionMobileser
        }
      }));

      const mobiliserData = sessionDetail.current.mobiliser_tagged?.length > 0 ? sessionDetail.current.mobiliser_tagged.map((ele: any) => {
        return `${ele?.mobiliser_f_name} ${ele?.mobiliser_l_name}`
      }) : '';
      const mobiliserValue = sessionMobileser.filter((ele: any) => mobiliserData.includes(ele.value)).map((ele: any) => {
        return ele.value;
      });

      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        mobiliserTagged: {
          ...prevState.mobiliserTagged,
          value: mobiliserValue,
          option: sessionMobileser
        }
      }));
    }
  };

  const getVillageCoverageSessionSite = async (facilityId: any) => {
    const res = await getVillageCoverageSessionSiteApi(facilityId);
    if (res) {
      const villagesCovered = res.data.map((key: any) => {
        return {
          value: key?.village_name,
          label: key?.village_name,
          id: key?.village_id,
          code: key?.village_code
        }
      });
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        vilagesCovered: {
          ...create_sessionDetails.vilagesCovered,
          '#options': villagesCovered
        }
      }));

      const villagesData = sessionDetail.current.village_coverage?.length > 0 ? sessionDetail.current.village_coverage.map((ele: any) => {
        return `${ele?.village_name}`
      }) : '';
      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        vilagesCovered: {
          ...prevState.vilagesCovered,
          value: villagesData,
          option: villagesCovered
        }
      }));
    }
  };

  const getWardCoverageSessionSite = async (facilityId: any) => {
    const res = await getWardCoverageSessionSiteApi(facilityId);
    if (res) {
      const wardsCovered = res.data.map((key: any) => {
        return {
          value: key?.ward_name,
          label: key?.ward_name,
          id: key?.ward_id,
          code: key?.ward_code
        }
      })

      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        wardsCovered: {
          ...create_sessionDetails.wardsCovered,
          '#options': wardsCovered
        }
      }));

      const wardsData = sessionDetail.current.ward_coverage?.length > 0 ? sessionDetail.current.ward_coverage.map((ele: any) => {
        return `${ele?.ward_name}`
      }) : '';
      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        wardsCovered: {
          ...prevState.wardsCovered,
          value: wardsData,
          option: wardsCovered
        }
      }));
    }

    setcheckLastApiCallSuccess(false);
  };

  const getUserLocationFacility = async () => {
    setShowLoader(true);
    const res = await getUserLocationFacilityApi();
    if (res) {
      userLocationDetailsRef.current = res.data;
      res.data.facility_id ? getVillageCoverageSessionSite(res.data.facility_id) : '';
      res.data.facility_id ? getWardCoverageSessionSite(res.data.facility_id) : '';
      setShowLoader(false);
      setcheckLastApiCallSuccess(true);
      setSessionFormStateInitial();
      setSessionFormDataInitial();
    }
  };

  const getSessionTypeSessionSite = async () => {
    const res = await getSessionTypeSessionSiteApi();
    if (res) {
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        sessionType: {
          ...create_sessionDetails.sessionType,
          '#options': res.data.map((key: any) => {
            return {
              value: key?.session_type_name,
              label: key?.session_type_name,
              id: key?.session_type_id,
              code: key?.session_type_code
            }
          })
        }
      }));
    }
  };

  const getSessionHeldAtSessionSite = async () => {
    const res = await getSessionHeldAtSessionSiteApi();
    if (res) {
      sessionHeldAtRef.current = res.data.map((key: any) => {
        return {
          value: key?.session_held_at_name,
          label: key?.session_held_at_name,
          id: key?.session_held_at_id,
          code: key?.session_held_at_code
        }
      });
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        sessionHeldAt: {
          ...create_sessionDetails.sessionHeldAt,
          '#options': sessionHeldAtRef.current
        }
      }));
    }
  };

  const setSessionFormStateInitial = () => {
    setsessionDetailsFormState((prevState: any) => ({
      ...prevState,
      sessionType: {
        ...prevState.sessionType,
        value: sessionDetail.current.session_type_name,
        id: sessionDetail.current.session_type_id,
        code: sessionDetail.current.session_type_code,
      },
      sessionName: {
        ...prevState.sessionName,
        value: (flow == 'duplicate') ? '' : sessionDetail.current.session_name,
      },
      sessionDate: {
        ...prevState.sessionDate,
        value: (flow == 'duplicate') ? '' : dayjs(sessionDetail.current.session_planned_date),
      },
      sessionHeld: {
        ...prevState.sessionHeld,
        value: sessionDetail.current.is_session_held_at_facility,
      },
      lattitude: {
        ...prevState.lattitude,
        value: sessionDetail.current.session_latitude,
      },
      longitude: {
        ...prevState.longitude,
        value: sessionDetail.current.session_longitude,
      },
      sessionHeldAt: {
        ...prevState.sessionHeldAt,
        value: sessionDetail.current.is_session_held_at_facility ? sessionDetail.current.facility_name : sessionDetail.current.session_held_at_name,
        id: sessionDetail.current.is_session_held_at_facility ? sessionDetail.current.facility_id : sessionDetail.current.session_held_at_id,
        code: sessionDetail.current.is_session_held_at_facility ? sessionDetail.current.facility_id : sessionDetail.current.session_held_at_code,
      },
      sessionSiteAddress: {
        ...prevState.sessionSiteAddress,
        value: sessionDetail.current.session_site_address,
      },
      coverageArea: {
        ...prevState.coverageArea,
        value: (sessionDetail.current.coverage_area && sessionDetail.current.coverage_area?.length > 0) ? sessionDetail.current.coverage_area.map((ele: any) => {
          return {
            address: ele.coverage_area, locationDetail: ele.coverage_lat_long
          }
        }) : [],
      }
    }));
    sesssionDateRef.current = dayjs(sessionDetail.current.session_planned_date).format(dateFormate.yyyy_mm_dd);
    getHealthProviderByFacilitySessionSite(userLocationDetailsRef.current?.facility_id, sesssionDateRef.current);
  };

  const setSessionFormDataInitial = () => {
    setSessionDetailsFormData((create_sessionDetails: any) => ({
      ...create_sessionDetails,
      sessionType: {
        ...create_sessionDetails.sessionType,
        '#isDisabled': (flow === 'duplicate') ? false : true,
      },
      sessionHeldAt: {
        ...create_sessionDetails.sessionHeldAt,
        '#isDisabled': sessionDetail.current.is_session_held_at_facility,
      },
      sessionSiteAddress: {
        ...create_sessionDetails.sessionSiteAddress,
        '#isDisabled': sessionDetail.current.is_session_held_at_facility
      },
    }));
  };

  const getSessionDetailById = async () => {
    setShowLoader(true);
    const res = await getSessionDetailByIdApi(id);
    if (res) {
      sessionDetail.current = res.data[0];

      if (flow == 'edit' || flow == 'duplicate') {
        (sessionDetail.current.coverage_area && sessionDetail.current.coverage_area?.length > 0) ? dispatch(setMapServicesPolygonForEdit(true)) : '';
        setTimeout(() => {
          getUserLocationFacility();
          getSessionTypeSessionSite();
          getSessionHeldAtSessionSite();
        }, 500);
      } else {
        setShowLoader(false);
      }

    }
  };

  const getSessionDetailStatus = async () => {
    const res = await getSessionDetailStatusApi();
    if (res) {
      sessionStatus.current = res.data;
    }
  };

  const handleSessionDetailsDataChangeOnMapFails = useCallback((data: any) => {
    setSessionDetailsFormData((prevState: any) => ({
      ...prevState,
      sessionSiteCoverageArea: {
        '#type': 'textfield',
        '#title': 'Coverage Area',
        '#webform_key': 'sessionSiteCoverageArea',
        '#required': true,
        '#isDisabled': data ? data : false,
      }
    }));
  }, []);

  const handSessionHeldChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
    if (value) {
      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          code: code,
          option: option,
          isError: false,
          message: '',
        },
        sessionHeldAt: {
          ...prevState.sessionHeldAt,
          value: userLocationDetailsRef.current?.facility_name,
          id: userLocationDetailsRef.current?.facility_id,
          code: userLocationDetailsRef.current?.facility_id,
          option: [{
            value: userLocationDetailsRef.current?.facility_name,
            label: userLocationDetailsRef.current?.facility_name,
            id: userLocationDetailsRef.current?.facility_id,
            code: userLocationDetailsRef.current?.facility_id
          }],
          isError: false,
          message: '',
        }
      }));
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        sessionHeldAt: {
          ...create_sessionDetails.sessionHeldAt,
          '#isDisabled': true,
          '#options': [{
            value: userLocationDetailsRef.current?.facility_name,
            label: userLocationDetailsRef.current?.facility_name,
            id: userLocationDetailsRef.current?.facility_id,
            code: userLocationDetailsRef.current?.facility_id
          }]
        },
        sessionSiteAddress: {
          ...create_sessionDetails.sessionSiteAddress,
          '#isDisabled': true
        }
      }));
    } else {
      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          code: code,
          option: option,
          isError: false,
          message: '',
        },
        sessionHeldAt: {
          ...prevState.sessionHeldAt,
          value: sessionDetail.current.session_held_at_name ? sessionDetail.current.session_held_at_name : '',
          id: sessionDetail.current.session_held_at_id ? sessionDetail.current.session_held_at_id : '',
          code: sessionDetail.current.session_held_at_code ? sessionDetail.current.session_held_at_code : '',
          option: sessionDetail.current.session_held_at_name ? sessionHeldAtRef.current : [],
          isError: false,
          message: '',
        }
      }));
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        sessionHeldAt: {
          ...create_sessionDetails.sessionHeldAt,
          '#isDisabled': false,
          '#options': sessionHeldAtRef.current
        },
        sessionSiteAddress: {
          ...create_sessionDetails.sessionSiteAddress,
          '#isDisabled': false
        }
      }));
    }
  }, []);

  const handleHpTaggedChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
    setsessionDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        option: option,
        isError: false,
        message: '',
      },
      mobiliserTagged: {
        ...prevState.mobiliserTagged,
        value: '',
        id: '',
        code: '',
        option: '',
        isError: false,
        message: '',
      },
    }));
    if (value && value.length > 0) {
      getMobiliserByFacilitySessionSite(JSON.parse(JSON.stringify(value)), JSON.parse(JSON.stringify(option)), sesssionDateRef.current)
    } else {
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        mobiliserTagged: {
          ...create_sessionDetails.mobiliserTagged,
          '#options': []
        }
      }));
    }
  }, []);

  const handleSessionDataChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
    setsessionDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        option: option,
        isError: false,
        message: '',
      },
      hpTagged: {
        ...prevState.hpTagged,
        value: '',
        isError: false,
        message: '',
      },
      mobiliserTagged: {
        ...prevState.mobiliserTagged,
        value: '',
        isError: false,
        message: '',
      },
    }));
    if (value) {
      sesssionDateRef.current = dayjs(value).format(dateFormate.yyyy_mm_dd);
      getHealthProviderByFacilitySessionSite(userLocationDetailsRef.current?.facility_id, sesssionDateRef.current);
    } else {
      sesssionDateRef.current = '';
      setSessionDetailsFormData((create_sessionDetails: any) => ({
        ...create_sessionDetails,
        hpTagged: {
          ...create_sessionDetails.hpTagged,
          '#options': []
        },
        mobiliserTagged: {
          ...create_sessionDetails.mobiliserTagged,
          '#options': []
        }
      }));
    }
  }, []);

  const handleSessionDetailsFormChange = useCallback((value: string | boolean | any, key: string | any, id: any, option: any, code: any) => {
    if (key == 'sessionHeld') {
      handSessionHeldChange(value, key, id, option, code);
    } else if (key == 'sessionDate') {
      handleSessionDataChange(value, key, id, option, code);
    } else if (key == 'hpTagged') {
      handleHpTaggedChange(value, key, id, option, code);
    } else {
      setsessionDetailsFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          code: code,
          option: option,
          isError: false,
          message: '',
        },
      }));
    }
  }, []);

  const handleSessionDetailsCoverageArea = useCallback((value: any, key: any) => {
    setsessionDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
      },
    }));
  }, []);

  const handleSessionDetailsError = useCallback((value: any, key: string) => {
    setsessionDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        ...value
      },
    }));
  }, []);

  const navigateToEdit = () => {
    navigate(`/VHND/edit/${id}`);
  };

  const navigateToDuplicateEvent = () => {
    navigate(`/VHND/create-duplicate-session/${id}`);
  };

  const handleBack = (pageFlow: any) => {
    navigate(pageFlow ? `/VHND/${pageFlow}/${id}` : `/VHND`);
    clearMapStore();
  };

  useEffect(() => {
    setTabs(NAV_ITEMS_MODAL);
    getSessionDetailById();
    if (flow == 'view') {
      getSessionDetailStatus();
    }

  }, [flow]);

  const handleArrayIds = (data: any) => {
    const idArray = data.option.filter((ele: any) => data.value.includes(ele.value)).map((ele: any) => {
      return ele.id;
    });

    return idArray;
  };

  const checkFormValid = () => {
    const sessionDetailsTempChange = JSON.parse(JSON.stringify(sessionDetailsFormState));
    let isFormError = false;
    Object.keys(sessionDetailsTempChange).map((item) => {
      if (item === 'sessionType') {
        if (!sessionDetailsTempChange.sessionType.value) {
          sessionDetailsTempChange.sessionType.isError = true;
          sessionDetailsTempChange.sessionType.message = session_message.sessionType.message;
          isFormError = true;
        } else {
          sessionDetailsTempChange.sessionType.isError = false;
        }
      } else if (item === 'sessionName') {
        if (!sessionDetailsTempChange.sessionName.value) {
          sessionDetailsTempChange.sessionName.isError = true;
          sessionDetailsTempChange.sessionName.message = session_message.sessionName.message;
          isFormError = true;
        } else {
          if (flow === 'duplicate') {
            if ((sessionDetail.current?.session_status_code == status_type.cancle.session_status_code) && (sessionDetailsTempChange.sessionName.value == sessionDetail.current?.session_name)) {
              sessionDetailsTempChange.sessionName.isError = true;
              sessionDetailsTempChange.sessionName.message = session_message.sessionName.messageForDuplicateName;
              isFormError = true;
            } else {
              sessionDetailsTempChange.sessionName.isError = false;
              sessionDetailsTempChange.sessionName.message = '';
            }
          } else {
            sessionDetailsTempChange.sessionName.isError = false;
            sessionDetailsTempChange.sessionName.message = '';
          }
        }
      } else if (item === 'sessionDate') {
        if (!sessionDetailsTempChange.sessionDate.value) {
          sessionDetailsTempChange.sessionDate.isError = true;
          sessionDetailsTempChange.sessionDate.message = session_message.sessionDate.message;
          isFormError = true;
        } else {
          if (flow === 'duplicate') {
            const alreadySessionDate = dayjs(dayjs(sessionDetail.current?.session_planned_date).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
            const changedSessionDate = dayjs(dayjs(sessionDetailsTempChange.sessionDate.value).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
            const currentDate = dayjs(dayjs(new Date()).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
            if ((sessionDetail.current?.session_status_code !== status_type.cancle.session_status_code)) {
              if (alreadySessionDate.isSame(changedSessionDate)) {
                sessionDetailsTempChange.sessionDate.isError = true;
                sessionDetailsTempChange.sessionDate.message = session_message.sessionDate.messageForDuplicateDate;
                isFormError = true;
              } else {
                sessionDetailsTempChange.sessionDate.isError = false;
                sessionDetailsTempChange.sessionDate.message = '';
              }
            } else {
              if (alreadySessionDate.isBefore(currentDate)) {
                sessionDetailsTempChange.sessionDate.isError = true;
                sessionDetailsTempChange.sessionDate.message = session_message.sessionDate.messageForDuplicateDate;
                isFormError = true;
              } else {
                sessionDetailsTempChange.sessionDate.isError = false;
                sessionDetailsTempChange.sessionDate.message = '';
              }
            }
          } else {
            sessionDetailsTempChange.sessionDate.isError = false;
            sessionDetailsTempChange.sessionDate.message = '';
          }
        }
      } else if (item === 'sessionHeldAt') {
        if (!sessionDetailsTempChange.sessionHeldAt.value) {
          sessionDetailsTempChange.sessionHeldAt.isError = true;
          sessionDetailsTempChange.sessionHeldAt.message = session_message.sessionHeldAt.message;
          isFormError = true;
        } else {
          sessionDetailsTempChange.sessionHeldAt.isError = false;
        }
      } else if (item === 'sessionSiteAddress') {
        if (!sessionDetailsTempChange.sessionSiteAddress.value) {
          sessionDetailsTempChange.sessionSiteAddress.isError = true;
          sessionDetailsTempChange.sessionSiteAddress.message = session_message.sessionSiteAddress.message;
          isFormError = true;
        } else {
          if (sessionDetailsTempChange.lattitude.value && sessionDetailsTempChange.longitude.value) {
            sessionDetailsTempChange.sessionSiteAddress.isError = false;
          } else {
            sessionDetailsTempChange.sessionSiteAddress.isError = true;
            sessionDetailsTempChange.sessionSiteAddress.message = session_message.sessionSiteAddress.messageForSuggestion;
            isFormError = true;
          }
        }
      } else if (item === 'hpTagged') {
        if (!sessionDetailsTempChange.hpTagged.value.length || sessionDetailsTempChange.hpTagged.value.length.length == 0) {
          sessionDetailsTempChange.hpTagged.isError = true;
          sessionDetailsTempChange.hpTagged.message = session_message.hpTagged.message;
          isFormError = true;
        } else {
          sessionDetailsTempChange.hpTagged.isError = false;
        }
      } else if (item === 'mobiliserTagged') {
        if ((!sessionDetailsTempChange.mobiliserTagged.value || sessionDetailsTempChange.mobiliserTagged.value.length == 0) && sessionDetailsFormData.mobiliserTagged['#required'] === true) {
          sessionDetailsTempChange.mobiliserTagged.isError = true;
          sessionDetailsTempChange.mobiliserTagged.message = session_message.mobiliserTagged.message;
          isFormError = true;
        } else {
          sessionDetailsTempChange.mobiliserTagged.isError = false;
        }
      } else if (item === 'vilagesCovered') {
        if ((!sessionDetailsTempChange.vilagesCovered.value || sessionDetailsTempChange.vilagesCovered.value.length.length == 0) && sessionDetailsFormData.vilagesCovered['#required'] === true) {
          sessionDetailsTempChange.vilagesCovered.isError = true;
          sessionDetailsTempChange.vilagesCovered.message = session_message.vilagesCovered.message;
          isFormError = true;
        } else {
          sessionDetailsTempChange.vilagesCovered.isError = false;
        }
      } else if (item === 'wardsCovered') {
        if ((!sessionDetailsTempChange.wardsCovered.value || sessionDetailsTempChange.wardsCovered.value.length.length == 0) && sessionDetailsFormData.wardsCovered['#required'] === true) {
          sessionDetailsTempChange.wardsCovered.isError = true;
          sessionDetailsTempChange.wardsCovered.message = session_message.wardsCovered.message;
          isFormError = true;
        } else {
          sessionDetailsTempChange.wardsCovered.isError = false;
        }
      } else if (item === 'coverageArea') {
        if (!facilityGeoMap.mapServicesDown  && config.enableArcGISMap === 'ON') {
          if (!sessionDetailsTempChange.coverageArea.value || sessionDetailsTempChange.coverageArea.value.length == 0) {
            sessionDetailsTempChange.coverageArea.isError = true;
            sessionDetailsTempChange.coverageArea.message = session_message.sessionSiteCoverageArea.message;
            isFormError = true;
          } else {
            if (!facilityGeoMap.createPolygone) {
              sessionDetailsTempChange.coverageArea.isError = true;
              sessionDetailsTempChange.coverageArea.message = session_message.sessionSiteCoverageArea.message2;
              isFormError = true;
            } else {
              sessionDetailsTempChange.coverageArea.isError = false;
            }
          }
        }
      }
    });
    setsessionDetailsFormState(sessionDetailsTempChange);

    return isFormError
  };

  const handleSuccessAction = (flow: any) => {
    toast.success(flow === 'edit' ? session_message.sessionCreationUpdateMessage : session_message.duplicateSessionCreationSuccessMessage, {
      position: 'top-center',
    });
    clearMapStore();
    navigate(`/VHND`);
  };

  const handleSaveAndUpdate = async () => {
    const isFormError = checkFormValid();

    if (!isFormError) {
      if (!facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') {
        if ((facilityGeoMap.distFenceGeometry && facilityGeoMap.mapPointer) && !geometryEngine.contains(facilityGeoMap.distFenceGeometry, facilityGeoMap.mapPointer)) {
          toast.error(map_message.sessionGeometryMessage, {
            position: "top-center",
          });

          return;
        }
      }
    } else {
      return;
    }

    // final update or duplicate call.
    const payLoad = {
      "sessionTypeId": sessionDetailsFormState.sessionType?.id ? sessionDetailsFormState.sessionType?.id : '',
      "sessionName": sessionDetailsFormState.sessionName?.value ? sessionDetailsFormState.sessionName?.value : '',
      "sessionPlannedDate": sessionDetailsFormState.sessionDate?.value ? dayjs(sessionDetailsFormState.sessionDate?.value).format(dateFormate.yyyy_mm_dd) : '',
      "isSessionHeldAtFacility": sessionDetailsFormState.sessionHeld?.value ? sessionDetailsFormState.sessionHeld?.value : false,
      "sessionLat": sessionDetailsFormState.lattitude?.value ? sessionDetailsFormState.lattitude?.value : '',
      "sessionLong": sessionDetailsFormState.longitude?.value ? sessionDetailsFormState.longitude?.value : '',
      "facilityId": sessionDetailsFormState.sessionHeld?.value ? sessionDetailsFormState.sessionHeldAt?.id ? sessionDetailsFormState.sessionHeldAt?.id : null : null,
      "temporarySessionHeldAtId": !sessionDetailsFormState.sessionHeld?.value ? sessionDetailsFormState.sessionHeldAt?.id ? sessionDetailsFormState.sessionHeldAt?.id : null : null,
      "sessionSiteAddress": sessionDetailsFormState.sessionSiteAddress?.value ? sessionDetailsFormState.sessionSiteAddress?.value : '',
      "healthProviderTaggedIds": sessionDetailsFormState.hpTagged?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.hpTagged))) : [],
      "mobileUserTaggedIds": sessionDetailsFormState.mobiliserTagged?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.mobiliserTagged))) : [],
      "villageCoverageIds": sessionDetailsFormState.vilagesCovered?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.vilagesCovered))) : [],
      "wardCoverageIds": sessionDetailsFormState.wardsCovered?.value.length > 0 ? handleArrayIds(JSON.parse(JSON.stringify(sessionDetailsFormState.wardsCovered))) : [],
      "coverageDetails": sessionDetailsFormState.coverageArea?.value.length > 0 ? sessionDetailsFormState.coverageArea?.value.map((ele: any) => {
        return {
          "area_name": ele.address,
          "area_latlong": ele.locationDetail
        }
      }) : []
    };

    let response: any = '';
    if (flow == 'edit') {
      response = await updateSessionApi(payLoad, id);
      if (response) {
        handleSuccessAction(flow);
      }
    } else if (flow == 'duplicate') {
      response = await createSessionApi(payLoad);
      if (response) {
        handleSuccessAction(flow);
      }
    }
  };

  const createReturnData = (sessionDate: any, currentDate: any) => {
    const data = ((sessionDetail.current?.session_status_code == status_type.cancle.session_status_code)
      || sessionDate.isBefore(currentDate)) ? true : false;

    return data;
  };

  const createDate = () => {
    const sessionDate = dayjs(dayjs(sessionDetail.current?.session_planned_date).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
    const currentDate = dayjs(dayjs(new Date()).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
    const data = {
      sessionDate: sessionDate,
      currentDate: currentDate
    }

    return data;
  };

  const disableToOpenEdit = () => {
    const { sessionDate, currentDate } = createDate();
    return createReturnData(sessionDate, currentDate);
  };

  const disableConfirm = () => {
    const { sessionDate, currentDate } = createDate();
    return sessionDate.isBefore(currentDate) ? true : false;
  };

  const disableCancel = () => {
    const { sessionDate, currentDate } = createDate();
    return (sessionDate.isBefore(currentDate) || sessionDate.isSame(currentDate)) ? true : false;
  };

  const disableUpdateButton = () => {
    const { sessionDate, currentDate } = createDate();
    return flow === 'edit' ? createReturnData(sessionDate, currentDate) : false;
  };

  const handleStatusModal = (data: boolean, type: string) => {
    setSessionStatusType(type);
    setShowWarningModal(data);
  };

  const handleStatusSubmit = async (statusCode: any) => {
    const filterArray = sessionStatus.current.filter((ele: any) => ele.session_status_code == statusCode);

    const payLoad = {
      sessionId: id,
      statusId: filterArray?.[0].session_status_id,
      statusCode: statusCode
    };
    const response = await statusSessionApi(payLoad);
    if (response) {
      handleStatusModal(false, '');
      getSessionDetailById();
      toast.success(`Event ${statusCode} successfully.`, {
        position: 'top-center',
      });
    }
  };


  return (
    <>
      <div className="app-session-view-wrapper">
        <header className="view-header">
          <div className="logo-wrapper">
            <NationalEmblem className="logo" />
            <div className="name-wrapper">
              <div className="name-wrapper-title">
                {viewHeader.text1}
              </div>
              <div className="name-wrapper-subtext">
                {viewHeader.text2}
              </div>
              <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>{viewHeader.text3}</div>
            </div>
          </div>
          <div className="view-route">
            <BreadcrumbComponent
              breadcrumbItemName={[
                { value: page, label: 'Geographical Entities' },
                { value: page, label: 'Session Site' },
              ]}
            />
          </div>
        </header>
        <main className="view-content">
          <div className="view-profile-buttons">
            <div className="view-profile">
              <CommonHamburgar>
                <LeftNavBar
                  navItems={tabs}
                  currentTab={currentTab}
                  handleNavClick={setCurrentTab}
                />
              </CommonHamburgar>
              <Button
                onClick={() => handleBack('')}
                disabled={false}
                id=""
                dataTestId='back-arrow-button'
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
              <img
                className="profile-picture"
                src={profilePic}
                alt='Profile Image'
              />
              <div className="name-type">
                <div className="name">{`${decodedUserData?.first_name} ${decodedUserData?.last_name}`}</div>
                <div className="type">{`${decodedUserData?.usertype_name} > ${decodedUserData?.user_designation_name}`}</div>
                <div className="type">{`Session Status - ${sessionDetail.current?.session_status_name || ''}`}</div>
              </div>
            </div>
            {!showLoader && <div className="cancel-edit">
              {(flow == 'edit' || flow == 'duplicate') && <Button
                onClick={() => handleBack('view')}
                disabled={false}
                id="cancel"
                buttonName={buttonNames.cancel}
                colorType={'save'}
                icon={''}
                iconPosition={'right'}
              />}
              {(flow == 'edit' || flow == 'duplicate') && <Button
                onClick={handleSaveAndUpdate}
                disabled={disableUpdateButton()}
                id={'save-details'}
                buttonName={flow === 'edit' ? buttonNames.update : buttonNames.createDuplicate}
                colorType={'primary'}
                icon={''}
                iconPosition={'right'}
              />}
              {(flow == 'view' && (sessionDetail.current?.session_status_code !== status_type.cancle.session_status_code && sessionDetail.current?.session_status_code !== status_type.confirm.session_status_code)) && <Button
                onClick={() => handleStatusModal(true, status_type.confirm.session_status_name)}
                disabled={disableConfirm()}
                id={'confirm-details'}
                buttonName={buttonNames.confirm}
                colorType={'save'}
                icon={''}
                iconPosition={'right'}
              />}
              {flow == 'view' && <Button
                onClick={navigateToDuplicateEvent}
                disabled={false}
                id={'duplicate-details'}
                buttonName={buttonNames.duplicate}
                colorType={'duplicate'}
                icon={<CopyLeft />}
                iconPosition={'left'}
              />}
              {(flow == 'view' && sessionDetail.current?.session_status_code !== status_type.cancle.session_status_code) && <Button
                onClick={() => handleStatusModal(true, status_type.cancle.session_status_name)}
                disabled={disableCancel()}
                id="cancel-event"
                buttonName={`${buttonNames.cancel} Session`}
                colorType={'save'}
                icon={''}
                iconPosition={'right'}
              />}
              {flow == 'view' && <Button
                onClick={navigateToEdit}
                disabled={disableToOpenEdit()}
                id={'edit-details'}
                buttonName={buttonNames.edit}
                colorType={'primary'}
                icon={<EditEvent />}
                iconPosition={'left'}
              />}
            </div>}
          </div>
          <div className="content">
            <LeftNavBar
              navItems={tabs}
              currentTab={currentTab}
              handleNavClick={setCurrentTab}
            />

            <div className='tab-content'>
              {!showLoader ? <>
                {(currentTab === NAV_ITEMS_MODAL[0] && flow === 'view') && <>{sessionDetail.current && <VhndUhndOverview sessionDetail={sessionDetail.current} flow={flow} />}</>}
                {(currentTab === NAV_ITEMS_MODAL[0] && (flow === 'edit' || flow === 'duplicate')) && <>
                  {(userLocationDetailsRef.current && !checkLastApiCallSuccess) && <EditDuplicateVhndUhndWrapper sessionDetail={sessionDetail.current} flow={flow}><SessionForm formData={sessionDetailsFormData} formState={sessionDetailsFormState} handleFormChange={handleSessionDetailsFormChange} handleSessionDetailsError={handleSessionDetailsError} handleSessionDetailsDataChangeOnMapFails={handleSessionDetailsDataChangeOnMapFails} userLocationDetails={userLocationDetailsRef.current} handleSessionDetailsCoverageArea={handleSessionDetailsCoverageArea} flow={flow} sessionDetail={sessionDetail.current} /></EditDuplicateVhndUhndWrapper>}
                </>}
              </> : <div className='loader'>Loading...</div>}
            </div>
          </div>
        </main>
      </div>
      <SessionSiteWarningModal
        handleCloseModal={() => handleStatusModal(false, '')}
        sessionStatusType={sessionStatusType}
        showWarningModal={showWarningModal}
        handleWarningModalBackButton={() => handleStatusModal(false, '')}
        handleFinalProceed={(statusCode: any) => handleStatusSubmit(statusCode)} 
      />

    </>
  );
};
export default VhndUhndView;